module.exports = __webpack_public_path__ + "img/IMG_5025.b7a71e24.jpg";